<template>
  <div class="order-info-card py-2.5">
    <p class="patient-count-label pl-2.5">Patient ({{ count }}/{{ totalCount }})</p>
    <div class="mt-3">
      <!-- Patient Name and Details -->
      <div class="flex flex-col items-center gap-1 justify-center">
        <el-tooltip :content="patientName" placement="top" effect="dark" :disabled="!isNameOverflow">
          <p class="patient-name truncate" style="max-width: 315px;">{{ patientName }}</p>
        </el-tooltip>
        <div class="flex items-center justify-center patient-gender-dob">
         <span v-if="gender">{{ gender }}</span>
          <span v-if="birthDate">|</span>
          <span v-if="birthDate">{{ formatBirthdate }}</span>
        </div>
      </div>
      <OrderedItemBaseCard
        class="mt-1.5"
        :name="testName"
        :original-price="originalPrice"
        :current-price="price"
        :test-name-list="testNameList"
        @clear="$emit('removeFamilyDiscountOrder')"
      >
        <template #original-price>
          <div class="flex items-center gap-1 text-sm">
            <p class="line-through text-red-500">{{ currency.symbol + originalPrice.toFixed(2) }}</p>
            <p>{{ currency.symbol + price.toFixed(2) }}</p>
          </div>
        </template>
      </OrderedItemBaseCard>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import OrderedItemBaseCard from '../../components/OrderedItemBaseCard.vue';
import moment from "moment";
export default {
  emits: ["removeFamilyDiscountOrder"],
  components: {
    OrderedItemBaseCard
  },
  props: {
    count: {
      type: Number,
      default: 1
    },
    totalCount: {
      type: Number,
      default: 1
    },
    patientName: {
      type: String,
      default: null
    },
    gender: {
      type: String,
      default: null
    },
    birthDate: {
      type: String,
      default: null
    },
    testName: {
      type: String,
      default: null
    },
    originalPrice: {
      type: Number,
      default: null
    },
    price: {
      type: Number,
      default: null
    },
    testNameList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isNameOverflow: false
    }
  },
  computed: {
    ...mapState(["currency"]),
    formatBirthdate() {
      return this.birthDate ? moment(this.birthDate).format("MMM-DD-YYYY") : "";
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isNameOverflow = this.getIsNameOverflow();
    });
  },
  methods: {
    getIsNameOverflow() {
      let nameElement = this.$el.getElementsByClassName('patient-name')[0];
      if (!nameElement) return false;
      return nameElement.scrollWidth > nameElement.clientWidth;
    }
  }
}
</script>

<style scoped>
.order-info-card {
  border-radius: 4px;
  background: #F9FBFD;
}

.patient-count-label {
  color: #666666;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}

.patient-name {
  color: #1E4670;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
}

.patient-gender-dob {
  color: #333333;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
}
</style>
